import { isTridentInIframe } from '../shared/utils/iframe.utils';

export class ModelConstants {
    public static readonly managedVirtualNetwork = 'managedVirtualNetwork';
    public static readonly managedPrivateEndpoint = 'managedPrivateEndpoint';
    public static readonly integrationRuntime = 'integrationRuntime';
    public static readonly notebook = 'notebook';
    public static readonly pbiNotebook = 'pbinotebook';
    public static readonly scopeJobDefinition = 'scopeJobDefinition';
    public static readonly database = 'database';
    public static readonly table = 'table';
    public static readonly relationship = 'relationship';
    public static readonly sqlScript = 'sqlscript';
    public static readonly kqlScript = 'kqlscript';
    public static readonly sparkJobDefinition = 'sparkJobDefinition';
    public static readonly sparkConfiguration = 'sparkConfiguration';
    public static readonly bigDataPool = 'bigDataPool';
    public static readonly sparkCompute = 'sparkCompute';
    public static readonly powerBIWorkspaceLinkedService = 'PowerBIWorkspace';
    public static readonly sqlPool = 'sqlPool';
    public static readonly sqlDatabase = 'sqlDatabase';
    public static readonly synapseStoredProcedure = 'SqlPoolStoredProcedure';
    public static readonly synapseNotebookActivity = 'SynapseNotebook';
    public static readonly tridentNotebookActivity = 'TridentNotebook';
    public static readonly tridentSparkJobDefinitionActivity = 'FabricSparkJobDefinition';
    public static readonly invokeCopyJob = 'InvokeCopyJob';
    public static readonly invokeDataBuildToolJob = 'InvokeDataBuildToolJob';
    public static readonly invokeDataQuality = 'InvokeDataQuality';
    public static readonly fabricApprovalActivity = 'Approval';
    public static readonly sparkJobActivity = 'SparkJob';
    public static readonly scopeJobActivity = 'ScopeJob';
    public static readonly credential = 'credential';
    public static readonly dataFactorySystemIdentity = 'DataFactorySystemIdentity';
    public static readonly managedIdentity = 'ManagedIdentity';
    public static readonly trigger = 'trigger';
    public static readonly lakehouseWriteSettings = 'LakehouseWriteSettings';
    public static readonly lakehouseTableCopySink = 'LakehouseTableCopySink';
    public static readonly workspace = 'Workspace';
    public static readonly copyJobActivity = 'copyjobActivity';
    public static readonly copyJob = 'copyjob';
    public static readonly microsoftTeams = 'MicrosoftTeams';
    public static readonly refreshSqlEndpointActivity = 'RefreshSqlEndpoint';
    public static readonly apiIntegrationActivity = 'ApiIntegration';
    public static readonly fabricActionsActivity = 'FabricActions';
    public static readonly businessActionsActivity = 'BusinessActions';


    // Pipeline
    public static readonly pipeline = 'pipeline';

    // Activities
    public static readonly amlExecutePipelineActivity = 'AzureMLExecutePipeline';
    public static readonly appendVariableActivity = 'AppendVariable';
    public static readonly azureDataExplorerCommandActivity = 'AzureDataExplorerCommand';
    public static readonly azureFunctionActivity = 'AzureFunctionActivity';
    public static readonly azureHDInsightActivity = 'AzureHDInsight';
    public static readonly mappingDataflowActivity = 'MappingDataFlow';
    public static readonly mappingDataflowfabricPipelineDataflowType = 'MappingDataflowFabric';
    public static readonly copyActivity = 'Copy';
    public static readonly customActivity = 'Custom';
    public static readonly dataflowRefreshActivity = 'RefreshDataflow';
    public static readonly dbtActivity = 'ExecuteDatabuildtool';
    public static readonly deleteActivity = 'Delete';
    public static readonly executeDataFlowActivity = 'ExecuteDataFlow';
    public static readonly executePipelineActivity = 'ExecutePipeline';
    public static readonly executePipelineActivityDuplicate = 'InvokePipeline';
    public static readonly executeSSISPackageActivity = 'ExecuteSSISPackage';
    public static readonly executeWranglingDataflowActivity = 'ExecuteWranglingDataflow';
    public static readonly semanticModelRefreshActivity = 'PBISemanticModelRefresh';
    public static readonly failActivity = 'Fail';
    public static readonly filterActivity = 'Filter';
    public static readonly forEachActivity = 'ForEach';
    public static readonly getMetadataActivity = 'GetMetadata';
    public static readonly ifConditionActivity = 'IfCondition';
    public static readonly kustoActivity = 'KustoCommand';
    public static readonly kqlActivity = 'KustoQueryLanguage';
    public static readonly lookupActivity = 'Lookup';
    public static readonly mapReduceActivity = 'HDInsightMapReduce';
    public static readonly notebookActivity = 'DatabricksNotebook';
    public static readonly pigActivity = 'HDInsightPig';
    public static readonly sapCommandActivity = 'SapCommand';
    public static readonly scopeActivity = 'DataLakeAnalyticsScope';
    public static readonly scriptActivity = 'Script';
    public static readonly scriptFlowActivity = 'ScriptFlowActivity';
    public static readonly setVariableActivity = 'SetVariable';
    public static readonly sparkActivity = 'HDInsightSpark';
    public static readonly sparkJarActivity = 'DatabricksSparkJar';
    public static readonly sparkPythonActivity = 'DatabricksSparkPython';
    public static readonly jobActivity = 'DatabricksJob';
    public static readonly streamingActivity = 'HDInsightStreaming';
    public static readonly switchActivity = 'Switch';
    public static readonly untilActivity = 'Until';
    public static readonly usqlActivity = 'DataLakeAnalyticsU-SQL';
    public static readonly validationActivity = 'Validation';
    public static readonly waitActivity = 'Wait';
    public static readonly webHookActivity = 'WebHook';
    public static readonly office365EmailActivity = 'Office365Email';
    public static readonly lakehouseMaintenanceActivity = 'LakehouseMaintenance';
    public static readonly materializedViewActivity = 'RefreshMaterializedLakeView';

    // CopySource
    public static readonly salesforceCopySource = 'SalesforceSource';
    public static readonly salesforceV2CopySource = isTridentInIframe() ? 'SalesforceSource' : 'SalesforceV2Source';
    public static readonly salesforceServiceCloudCopySource = 'SalesforceServiceCloudSource';
    public static readonly salesforceServiceCloudV2CopySource = isTridentInIframe() ? 'SalesforceServiceCloudSource' : 'SalesforceServiceCloudV2Source';
    public static readonly serviceNowCopySource = 'ServiceNowSource';
    public static readonly serviceNowV2CopySource = isTridentInIframe() ? 'ServiceNowSource' : 'ServiceNowV2Source';
    public static readonly snowflakeCopySource = 'SnowflakeSource';
    public static readonly snowflakeV2CopySource = isTridentInIframe() ? 'SnowflakeSource' : 'SnowflakeV2Source';
    public static readonly sqlAnalyticsEndpointCopySource = 'SqlAnalyticsEndpointSource';
    public static readonly genericCDataCopySource = 'GenericCDataSource';

    // CopySink
    public static readonly salesforceCopySink = 'SalesforceSink';
    public static readonly salesforceV2CopySink = isTridentInIframe() ? 'SalesforceSink' : 'SalesforceV2Sink';
    public static readonly salesforceServiceCloudCopySink = 'SalesforceServiceCloudSink';
    public static readonly salesforceServiceCloudV2CopySink = isTridentInIframe() ? 'SalesforceServiceCloudSink' : 'SalesforceServiceCloudV2Sink';
    public static readonly snowflakeCopySink = 'SnowflakeSink';
    public static readonly snowflakeV2CopySink = isTridentInIframe() ? 'SnowflakeSink' : 'SnowflakeV2Sink';

    // Datasets
    public static readonly dataset = 'dataset';
    public static readonly avroDataset = 'Avro';
    public static readonly delimitedTextDataset = 'DelimitedText';
    public static readonly icebergDataset = 'Iceberg';
    public static readonly deltaFormat = 'Delta';
    public static readonly jsonDataset = 'Json';
    public static readonly parquetDataset = 'Parquet';
    public static readonly xmlDataset = 'Xml';
    public static readonly excelDataset = 'Excel';
    public static readonly binaryDataset = 'Binary';
    public static readonly orcDataset = 'Orc';
    public static readonly deltaDataset = 'Delta';
    public static readonly azureDataExplorerDataset = 'AzureDataExplorerTable';
    public static readonly kustoDatabaseDataset = 'KustoDatabaseTable';
    public static readonly fabricSqlTableDataset = 'FabricSqlDatabaseTable';
    public static readonly sqlAnalyticsEndpointDataset = 'SqlAnalyticsEndpointTable';
    public static readonly mountedRelationalDatabaseDataset = 'GenericMirrorTable';
    public static readonly lakehouseTableDataset = 'LakehouseTable';
    public static readonly eventHubsDataset = 'EventHubsDataset';
    public static readonly eventStreamDataset = 'FabricEventStream';

    public static readonly synapseTableDataset = 'AzureSqlDWTable';
    public static readonly dataWarehouseTableDataset = 'DataWarehouseTable';
    public static readonly warehouseTableDataset = 'WarehouseTable';
    public static readonly sapODataDataset = 'SapODataResource';
    public static readonly salesforceDataset = 'SalesforceObject';
    public static readonly salesforceV2Dataset = isTridentInIframe() ? 'SalesforceObject' : 'SalesforceV2Object';
    public static readonly salesforceServiceCloudDataset = 'SalesforceServiceCloudObject';
    public static readonly salesforceServiceCloudV2Dataset = isTridentInIframe() ? 'SalesforceServiceCloudObject' : 'SalesforceServiceCloudV2Object';
    public static readonly serviceNowDataset = 'ServiceNowObject';
    public static readonly serviceNowV2Dataset = isTridentInIframe() ? 'ServiceNowObject' : 'ServiceNowV2Object';
    public static readonly snowflakeDataset = 'SnowflakeTable';
    public static readonly snowflakeV2Dataset = isTridentInIframe() ? 'SnowflakeTable' : 'SnowflakeV2Table';
    public static readonly sqlServerDataset = 'SqlServerTable';
    public static readonly genericCDataTableDataset = 'GenericCDataTable';

    // Data flows
    public static readonly dataFlow = 'dataflow';
    public static readonly pbiDataflow = 'pbidataflow';
    public static readonly dataFlowSource = 'source';
    public static readonly dataFlowSink = 'sink';
    public static readonly dataflowExpression = 'dataflowexpression';
    public static readonly powerquery = 'powerquery';
    public static readonly udflibrary = 'udflibrary';

    // Linked services
    public static readonly linkedService = 'linkedService';
    public static readonly cosmosDbLinkedService = 'CosmosDb';
    public static readonly adlsGen2LinkedService = 'AzureBlobFS';
    public static readonly blobLinkedService = 'AzureBlobStorage';
    public static readonly synapseLinkedService = 'AzureSqlDW';
    public static readonly dataWarehouseLinkedService = 'DataWarehouse';
    public static readonly warehouseLinkedService = 'Warehouse';
    public static readonly warehouseCredentialLinkedService = 'WarehouseCredential';
    public static readonly azurePostgreSqlLinkedService = 'AzurePostgreSql';
    public static readonly azureHorizonDbLinkedService = 'AzureHorizonDB';
    public static readonly azureMySqlLinkedService = 'AzureMySql';
    public static readonly snowflakeLinkedService = 'Snowflake';
    public static readonly snowflakeV2LinkedService = isTridentInIframe() ? 'Snowflake' : 'SnowflakeV2';
    public static readonly sqlServerLinkedService = 'SqlServer';
    public static readonly fileServerService = 'FileServer';
    public static readonly azureSqlMiDatabase = 'AzureSqlMI';
    public static readonly fileStorageService = 'AzureFileStorage';
    public static readonly azureSqlDatabase = 'AzureSqlDatabase';
    public static readonly eventHubsLinkedService = 'EventHubs';
    public static readonly cognitiveServiceLinkedService = 'CognitiveService';
    public static readonly lakehouseLinkedService = 'Lakehouse';
    public static readonly lakehouseCredentialLinkedService = 'LakehouseCredential';
    public static readonly azureDataExplorerLinkedService = 'AzureDataExplorer';
    public static readonly kustoDatabaseLinkedService = 'KustoDatabase';
    public static readonly sapCdcLinkedService = 'SapCDC';
    public static readonly oracleLinkedService = 'Oracle';
    public static readonly sharePointOnlineListLinkedService = 'SharePointOnlineList';
    public static readonly googleBigQueryLinkedService = 'GoogleBigQuery';
    public static readonly sapODataLinkedService = 'SapOData';
    public static readonly sapDatasphereForAzureDataLakeStorageGen2LinkedService = 'SapDatasphereForAzureDataLakeStorageGen2';
    public static readonly oneLakeFileLinkedService = 'OneLakeFiles';
    public static readonly sapDatasphereForGoogleCloudStorageLinkedService = 'SapDatasphereForGoogleCloudStorage';
    public static readonly sapDatasphereForAmazonS3LinkedService = 'SapDatasphereForAmazonS3';
    public static readonly sapBusinessDataCloudLinkedService = 'SAPBDC';
    public static readonly salesforceLinkedService = 'Salesforce';
    public static readonly salesforceV2LinkedService = isTridentInIframe() ? 'Salesforce' : 'SalesforceV2';
    public static readonly salesforceServiceCloudLinkedService = 'SalesforceServiceCloud';
    public static readonly salesforceServiceCloudV2LinkedService = isTridentInIframe() ? 'SalesforceServiceCloud' : 'SalesforceServiceCloudV2';
    public static readonly serviceNowLinkedService = 'ServiceNow';
    public static readonly serviceNowV2LinkedService = isTridentInIframe() ? 'ServiceNow' : 'ServiceNowV2';
    public static readonly fabricSqlLinkedService = 'FabricSqlDatabase';
    public static readonly fabricSqlCredentialLinkedService = 'FabricSqlDatabaseCredential';
    public static readonly sqlAnalyticsEndpointLinkedService = 'SqlAnalyticsEndpoint';
    public static readonly sqlAnalyticsEndpointCredentialLinkedService = 'sqlAnalyticsEndpointCredential';
    public static readonly fabricMaterializedLakehouseViewLinkedService = 'FabricMaterializedLakeView';
    public static readonly mountedRelationalDatabaseLinkedService = 'GenericMirror';
    public static readonly mountedRelationalDatabaseArtifactType = 'MountedRelationalDatabase';
    public static readonly dataflowFabricArtifactType = 'DataflowFabric';
    public static readonly azureTableLinkedService = 'AzureTableStorage';
    public static readonly pbiDatasetsLinkedService = 'PowerBIDatasets';
    public static readonly azureDatafactoryLinkedService = 'AzureDataFactory';
    public static readonly azureSynapseWorkspaceLinkedService = 'SynapseWorkspace';
    public static readonly azureMlLinkedService = 'AzureMLService';
    public static readonly fabricDataPipelinesLinkedService = 'FabricDataPipelines';
    public static readonly sparkJobDefinitionLinkedService = 'SparkJobDefinitionLS';
    public static readonly fabricNotebookLinkedService = 'FabricNotebookLS';
    public static readonly fabricAirflowLinkedService = 'FabricAirflowLS';
    public static readonly udfLinkedService = 'UserDataFunctionsLS';
    public static readonly fabricDataflowLinkedService = 'FabricDataflows';
    public static readonly invokeCopyJobLinkedService = 'InvokeCopyJobLS';
    public static readonly dataBuildToolJobLinkedService = 'DataBuildToolJob';
    public static readonly dataQualityLinkedService = 'DataQuality';
    public static readonly fabricWebLinkedService = 'FabricWeb';
    public static readonly microsoftTeamsLinkedService = 'MicrosoftTeamsLS';
    public static readonly genericCDataLinkedService = 'GenericCData';

    public static readonly ftpServerLinkedService = 'FtpServer';
    public static readonly hdfsLinkedService = 'Hdfs';
    public static readonly sftpLinkedService = 'Sftp';
    public static readonly office365EmailLinkedService = 'MicrosoftOutlook';
    public static readonly amazonS3LinkedService = 'AmazonS3';
    public static readonly amazonS3CompatibleLinkedService = 'AmazonS3Compatible';
    public static readonly googleCloudStorageLinkedService = 'GoogleCloudStorage';
    public static readonly azureBatchLinkedService = 'AzureBatch';
    public static readonly webActivityLinkedService = 'WebConnection';
    public static readonly hdiLinkedService = 'HDInsight';
    public static readonly hdiOnDemandLinkedService = 'HDInsightOnDemand';
    public static readonly fabricSqlEndpointMetadataLinkedService = 'FabricSqlEndpointMetadata';
    public static readonly azureDatabricksLinkedService = 'AzureDatabricks';
    public static readonly azureFunctionLinkedService = 'AzureFunction';
    public static readonly eventStreamLinkedService = 'EventStream';
    public static readonly eventStreamCredentialLinkedService = 'EventStreamCredential';

    //Artifacts
    public static readonly lakehouseArtifactType = 'Lakehouse';
    public static readonly kustoDatabaseArtifactType = 'KustoDatabase';
    public static readonly dataWarehouseArtifactType = 'DataWarehouse';
    public static readonly fabricSqlArtifactType = 'SQLDbNative';
    public static readonly sqlAnalyticsEndpointArtifactType = 'SqlAnalyticsEndpoint';
    public static readonly pipelineArtifactType = 'Pipeline';
    public static readonly dataflowArtifactType = 'Dataflow';
    public static readonly fabricDataflowArtifactType = 'DataflowFabric';
    public static readonly synapseNotebookArtifactType = 'SynapseNotebook';
    public static readonly workspaceArtifactType = 'Workspace';
    public static readonly copyJobArtifactType = 'CopyJob';
    public static readonly dbtItemArtifactType = 'DBTItem';
    public static readonly eventStreamArtifactType = 'EventStream';

    public static readonly azureCloudTypeConst = {
        AzurePublic: 'AzurePublic',
        AzureChina: 'AzureChina',
        AzureUSGovernment: 'AzureUSGovernment',
        AzureGermany: 'AzureGermany'
    };

    public static readonly switchActivityDefaultCase = 'Default';
    public static readonly ifActivityTrueSuffix = 'TrueActivities';
    public static readonly ifActivityFalseSuffix = 'FalseActivities';

    public static readonly servicePrincipal = 'ServicePrincipal';
    public static readonly servicePrincipalCredentialProperties = 'ServicePrincipalCredentialProperties';
    public static readonly federatedIdentityCredentialProperties = 'FederatedIdentityCredential';
    public static readonly managedIdentityCredentialProperties = 'ManagedIdentityCredentialProperties';
    public static readonly userAssignedManagedIdentityCredentialProperties = 'UserAssignedManagedIdentityCredentialProperties';
    public static readonly userAuthCredentialProperties = 'userAuthCredentialProperties';
    public static readonly emailCredentialProperties = 'EmailCredentialProperties';
    public static readonly teamsCredentialProperties = 'TeamsCredentialProperties';
    public static readonly azureBlobCredentialProperties = 'AzureBlobCredentialProperties';
    public static readonly azureDevopsCredentialProperties = 'AzureDevopsCredentialProperties';
    public static readonly azureDataFactoryCredentialProperties = 'AzureDataFactoryCredentialProperties';

    public static readonly databaseEntities = [ModelConstants.table, ModelConstants.relationship];

    // Synapse link
    public static readonly linkConnection = 'linkconnection';
    public static readonly linkTable = 'linktable';

    // Mapping Artifact
    // TODO: Remove once data mapper changes are checked in.
    public static readonly mappingArtifact = 'mappingartifact';

    // DataMapper
    public static readonly dataMapper = 'dataMapper';

    // ADF DataMapper
    public static readonly adfDataMapper = 'adfcdc';

    // ADF DataMapper Attribute Mappings
    public static readonly adfDataMapperAttributeMappings = 'adfDataMapperAttributeMappings';

    // Global parameters
    public static readonly globalparameters = 'globalparameters';

    //'Flowlet'
    public static readonly flowlet = 'flowlet';
}
